import React from "react";
import { useTranslation } from "react-i18next";

type LoadingImageProps = {
  width?: string;   // default: w-full
  height?: string;  // default: h-full
  className?: string;
};

export default function LoadingImage({
  width = "w-full",
  height = "h-full",
  className = "",
}: LoadingImageProps) {
  const { t } = useTranslation("common");
  return (
    <div
      role="status"
      aria-live="polite"
      className={`animate-pulse flex items-center justify-center ${width} ${height} bg-gray-200 rounded-md ${className}`}
    >
      <svg
        className="w-11 h-11 text-gray-400"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="m3 16 5-7 6 6.5m6.5 2.5L16 13l-4.286 6M14 10h.01M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"
        />
      </svg>
      <span className="sr-only">{t("Loading...")}</span>
    </div>
  );
}
